import React from "react";

import type { UI_CONTEXT } from "@/analytics/constants";

import Grid from "@/components/layout/grid";

import { CategoryProps } from "@/interfaces/category-interface";
import { CollectionProps } from "@/interfaces/collection-interface";
import { CollectionV2Props } from "@/interfaces/collection-v2-interface";
import { ProductProps } from "@/interfaces/products-interface";

import { ProductTile } from "./product-tile";

type Props = {
    products: Array<ProductProps>;
    uiContext: UI_CONTEXT;
    category: CategoryProps | CollectionProps | CollectionV2Props;
};

export const ProductTiles: React.FC<Props> = (props) => {
    const { products, category, uiContext } = props;
    return (
        <Grid fullWidth fullHeight>
            {products.map((product) => (
                <ProductTile
                    key={product.id}
                    product={product}
                    uiContext={uiContext}
                    category={category}
                />
            ))}
        </Grid>
    );
};
